webpackJsonp([114276838955818,60335399758886],{

/***/ 169:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(313);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(169);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(163);
	var isArguments = __webpack_require__(162);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 162:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 163:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Changes the hue of the color. Hue is a number between 0 to 360. The first
	 * argument for adjustHue is the amount of degrees the color is rotated along
	 * the color wheel.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: adjustHue(180, '#448'),
	 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${adjustHue(180, '#448')};
	 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#888844";
	 *   background: "rgba(136,136,68,0.7)";
	 * }
	 */
	function adjustHue(degree, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    hue: (hslColor.hue + degree) % 360
	  }));
	}
	
	var curriedAdjustHue = /*#__PURE__*/(0, _curry2.default)(adjustHue);
	exports.default = curriedAdjustHue;
	module.exports = exports['default'];

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: complement('#448'),
	 *   background: complement('rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${complement('#448')};
	 *   background: ${complement('rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#884";
	 *   background: "rgba(153,153,153,0.7)";
	 * }
	 */
	function complement(color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    hue: (hslColor.hue + 180) % 360
	  }));
	}
	
	exports.default = complement;
	module.exports = exports['default'];

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(53);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the darkened color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: darken(0.2, '#FFCD64'),
	 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${darken(0.2, '#FFCD64')};
	 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#ffbd31";
	 *   background: "rgba(255,189,49,0.7)";
	 * }
	 */
	function darken(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    lightness: (0, _guard2.default)(0, 1, hslColor.lightness - amount)
	  }));
	}
	
	var curriedDarken = /*#__PURE__*/(0, _curry2.default)(darken);
	exports.default = curriedDarken;
	module.exports = exports['default'];

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(53);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Decreases the intensity of a color. Its range is between 0 to 1. The first
	 * argument of the desaturate function is the amount by how much the color
	 * intensity should be decreased.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: desaturate(0.2, '#CCCD64'),
	 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${desaturate(0.2, '#CCCD64')};
	 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#b8b979";
	 *   background: "rgba(184,185,121,0.7)";
	 * }
	 */
	function desaturate(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    saturation: (0, _guard2.default)(0, 1, hslColor.saturation - amount)
	  }));
	}
	
	var curriedDesaturate = /*#__PURE__*/(0, _curry2.default)(desaturate);
	exports.default = curriedDesaturate;
	module.exports = exports['default'];

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(36);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number (float) representing the luminance of a color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
	 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
	 *                             'rgba(58, 133, 255, 1)' :
	 *                             'rgba(255, 57, 149, 1)',
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
	 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
	 *                             'rgba(58, 133, 255, 1)' :
	 *                             'rgba(255, 57, 149, 1)'};
	 *
	 * // CSS in JS Output
	 *
	 * div {
	 *   background: "#CCCD64";
	 *   background: "rgba(58, 133, 255, 1)";
	 * }
	 */
	function getLuminance(color) {
	  var rgbColor = (0, _parseToRgb2.default)(color);
	
	  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
	    var channel = rgbColor[key] / 255;
	    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
	  }),
	      r = _Object$keys$map[0],
	      g = _Object$keys$map[1],
	      b = _Object$keys$map[2];
	
	  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
	}
	exports.default = getLuminance;
	module.exports = exports['default'];

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts the color to a grayscale, by reducing its saturation to 0.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: grayscale('#CCCD64'),
	 *   background: grayscale('rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${grayscale('#CCCD64')};
	 *   background: ${grayscale('rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#999";
	 *   background: "rgba(153,153,153,0.7)";
	 * }
	 */
	function grayscale(color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    saturation: 0
	  }));
	}
	
	exports.default = grayscale;
	module.exports = exports['default'];

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToHex = /*#__PURE__*/__webpack_require__(250);
	
	var _hslToHex2 = /*#__PURE__*/_interopRequireDefault(_hslToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible hex notation.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: hsl(359, 0.75, 0.4),
	 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${hsl(359, 0.75, 0.4)};
	 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#b3191c";
	 *   background: "#b3191c";
	 * }
	 */
	function hsl(value, saturation, lightness) {
	  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
	    return (0, _hslToHex2.default)(value, saturation, lightness);
	  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
	    return (0, _hslToHex2.default)(value.hue, value.saturation, value.lightness);
	  }
	
	  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
	}
	
	exports.default = hsl;
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToHex = /*#__PURE__*/__webpack_require__(250);
	
	var _hslToHex2 = /*#__PURE__*/_interopRequireDefault(_hslToHex);
	
	var _hslToRgb = /*#__PURE__*/__webpack_require__(177);
	
	var _hslToRgb2 = /*#__PURE__*/_interopRequireDefault(_hslToRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: hsla(359, 0.75, 0.4, 0.7),
	 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
	 *   background: hsla(359, 0.75, 0.4, 1),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
	 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
	 *   background: ${hsla(359, 0.75, 0.4, 1)};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(179,25,28,0.7)";
	 *   background: "rgba(179,25,28,0.7)";
	 *   background: "#b3191c";
	 * }
	 */
	function hsla(value, saturation, lightness, alpha) {
	  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
	    return alpha >= 1 ? (0, _hslToHex2.default)(value, saturation, lightness) : 'rgba(' + (0, _hslToRgb2.default)(value, saturation, lightness) + ',' + alpha + ')';
	  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
	    return value.alpha >= 1 ? (0, _hslToHex2.default)(value.hue, value.saturation, value.lightness) : 'rgba(' + (0, _hslToRgb2.default)(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
	  }
	
	  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
	}
	
	exports.default = hsla;
	module.exports = exports['default'];

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(36);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Inverts the red, green and blue values of a color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: invert('#CCCD64'),
	 *   background: invert('rgba(101,100,205,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${invert('#CCCD64')};
	 *   background: ${invert('rgba(101,100,205,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#33329b";
	 *   background: "rgba(154,155,50,0.7)";
	 * }
	 */
	function invert(color) {
	  // parse color string to rgb
	  var value = (0, _parseToRgb2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, value, {
	    red: 255 - value.red,
	    green: 255 - value.green,
	    blue: 255 - value.blue
	  }));
	}
	
	exports.default = invert;
	module.exports = exports['default'];

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(53);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the lightened color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: lighten(0.2, '#CCCD64'),
	 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${lighten(0.2, '#FFCD64')};
	 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#e5e6b1";
	 *   background: "rgba(229,230,177,0.7)";
	 * }
	 */
	function lighten(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    lightness: (0, _guard2.default)(0, 1, hslColor.lightness + amount)
	  }));
	}
	
	var curriedLighten = /*#__PURE__*/(0, _curry2.default)(lighten);
	exports.default = curriedLighten;
	module.exports = exports['default'];

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rgba = /*#__PURE__*/__webpack_require__(104);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(36);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Mixes two colors together by calculating the average of each of the RGB components.
	 *
	 * By default the weight is 0.5 meaning that half of the first color and half the second
	 * color should be used. Optionally the weight can be modified by providing a number
	 * as the first argument. 0.25 means that a quarter of the first color and three quarters
	 * of the second color should be used.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: mix(0.5, '#f00', '#00f')
	 *   background: mix(0.25, '#f00', '#00f')
	 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${mix(0.5, '#f00', '#00f')};
	 *   background: ${mix(0.25, '#f00', '#00f')};
	 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#7f007f";
	 *   background: "#3f00bf";
	 *   background: "rgba(63, 0, 191, 0.75)";
	 * }
	 */
	function mix() {
	  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
	  var color = arguments[1];
	  var otherColor = arguments[2];
	
	  var parsedColor1 = (0, _parseToRgb2.default)(color);
	  var color1 = _extends({}, parsedColor1, {
	    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
	  });
	
	  var parsedColor2 = (0, _parseToRgb2.default)(otherColor);
	  var color2 = _extends({}, parsedColor2, {
	    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
	
	    // The formular is copied from the original Sass implementation:
	    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
	  });var alphaDelta = color1.alpha - color2.alpha;
	  var x = weight * 2 - 1;
	  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
	  var z = 1 + x * alphaDelta;
	  var weight1 = (y / z + 1) / 2.0;
	  var weight2 = 1 - weight1;
	
	  var mixedColor = {
	    red: Math.floor(color1.red * weight1 + color2.red * weight2),
	    green: Math.floor(color1.green * weight1 + color2.green * weight2),
	    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
	    alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
	  };
	
	  return (0, _rgba2.default)(mixedColor);
	}
	
	var curriedMix = /*#__PURE__*/(0, _curry2.default)(mix);
	exports.default = curriedMix;
	module.exports = exports['default'];

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rgba = /*#__PURE__*/__webpack_require__(104);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(36);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _guard = /*#__PURE__*/__webpack_require__(53);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
	 *
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
	 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
	 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
	 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
	 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#fff";
	 *   background: "rgba(255,255,255,0.7)";
	 *   background: "rgba(255,0,0,0.7)";
	 * }
	 */
	function opacify(amount, color) {
	  var parsedColor = (0, _parseToRgb2.default)(color);
	  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
	  var colorWithAlpha = _extends({}, parsedColor, {
	    alpha: (0, _guard2.default)(0, 1, (alpha * 100 + amount * 100) / 100)
	  });
	  return (0, _rgba2.default)(colorWithAlpha);
	}
	
	var curriedOpacify = /*#__PURE__*/(0, _curry2.default)(opacify);
	exports.default = curriedOpacify;
	module.exports = exports['default'];

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(36);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _rgbToHsl = /*#__PURE__*/__webpack_require__(539);
	
	var _rgbToHsl2 = /*#__PURE__*/_interopRequireDefault(_rgbToHsl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns an HslColor or HslaColor object. This utility function is only useful
	 * if want to extract a color component. With the color util `toColorString` you
	 * can convert a HslColor or HslaColor object back to a string.
	 *
	 * @example
	 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
	 * const color1 = 'rgb(255, 0, 0)';
	 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
	 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
	 */
	function parseToHsl(color) {
	  // Note: At a later stage we can optimize this function as right now a hsl
	  // color would be parsed converted to rgb values and converted back to hsl.
	  return (0, _rgbToHsl2.default)((0, _parseToRgb2.default)(color));
	}
	
	exports.default = parseToHsl;
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToRgb = /*#__PURE__*/__webpack_require__(177);
	
	var _hslToRgb2 = /*#__PURE__*/_interopRequireDefault(_hslToRgb);
	
	var _nameToHex = /*#__PURE__*/__webpack_require__(538);
	
	var _nameToHex2 = /*#__PURE__*/_interopRequireDefault(_nameToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexRegex = /^#[a-fA-F0-9]{6}$/;
	var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
	var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
	var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
	var hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
	var hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
	
	/**
	 * Returns an RgbColor or RgbaColor object. This utility function is only useful
	 * if want to extract a color component. With the color util `toColorString` you
	 * can convert a RgbColor or RgbaColor object back to a string.
	 *
	 * @example
	 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
	 * const color1 = 'rgb(255, 0, 0)';
	 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
	 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
	 */
	function parseToRgb(color) {
	  if (typeof color !== 'string') {
	    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
	  }
	  var normalizedColor = (0, _nameToHex2.default)(color);
	  if (normalizedColor.match(hexRegex)) {
	    return {
	      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
	      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
	      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
	    };
	  }
	  if (normalizedColor.match(reducedHexRegex)) {
	    return {
	      red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
	      green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
	      blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
	    };
	  }
	  var rgbMatched = rgbRegex.exec(normalizedColor);
	  if (rgbMatched) {
	    return {
	      red: parseInt('' + rgbMatched[1], 10),
	      green: parseInt('' + rgbMatched[2], 10),
	      blue: parseInt('' + rgbMatched[3], 10)
	    };
	  }
	  var rgbaMatched = rgbaRegex.exec(normalizedColor);
	  if (rgbaMatched) {
	    return {
	      red: parseInt('' + rgbaMatched[1], 10),
	      green: parseInt('' + rgbaMatched[2], 10),
	      blue: parseInt('' + rgbaMatched[3], 10),
	      alpha: parseFloat('' + rgbaMatched[4])
	    };
	  }
	  var hslMatched = hslRegex.exec(normalizedColor);
	  if (hslMatched) {
	    var hue = parseInt('' + hslMatched[1], 10);
	    var saturation = parseInt('' + hslMatched[2], 10) / 100;
	    var lightness = parseInt('' + hslMatched[3], 10) / 100;
	    var rgbColorString = 'rgb(' + (0, _hslToRgb2.default)(hue, saturation, lightness) + ')';
	    var hslRgbMatched = rgbRegex.exec(rgbColorString);
	    return {
	      red: parseInt('' + hslRgbMatched[1], 10),
	      green: parseInt('' + hslRgbMatched[2], 10),
	      blue: parseInt('' + hslRgbMatched[3], 10)
	    };
	  }
	  var hslaMatched = hslaRegex.exec(normalizedColor);
	  if (hslaMatched) {
	    var _hue = parseInt('' + hslaMatched[1], 10);
	    var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
	    var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
	    var _rgbColorString = 'rgb(' + (0, _hslToRgb2.default)(_hue, _saturation, _lightness) + ')';
	    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
	    return {
	      red: parseInt('' + _hslRgbMatched[1], 10),
	      green: parseInt('' + _hslRgbMatched[2], 10),
	      blue: parseInt('' + _hslRgbMatched[3], 10),
	      alpha: parseFloat('' + hslaMatched[4])
	    };
	  }
	  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
	}
	
	exports.default = parseToRgb;
	module.exports = exports['default'];

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getLuminance = /*#__PURE__*/__webpack_require__(246);
	
	var _getLuminance2 = /*#__PURE__*/_interopRequireDefault(_getLuminance);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Selects black or white for best contrast depending on the luminosity of the given color.
	 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   color: readableColor('#000'),
	 *   color: readableColor('papayawhip'),
	 *   color: readableColor('rgb(255,0,0)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   color: ${readableColor('#000')};
	 *   color: ${readableColor('papayawhip')};
	 *   color: ${readableColor('rgb(255,0,0)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   color: "#fff";
	 *   color: "#fff";
	 *   color: "#000";
	 * }
	 */
	
	function readableColor(color) {
	  return (0, _getLuminance2.default)(color) > 0.179 ? '#000' : '#fff';
	}
	
	var curriedReadableColor = /*#__PURE__*/(0, _curry2.default)(readableColor);
	exports.default = curriedReadableColor;
	module.exports = exports['default'];

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduceHexValue = /*#__PURE__*/__webpack_require__(253);
	
	var _reduceHexValue2 = /*#__PURE__*/_interopRequireDefault(_reduceHexValue);
	
	var _numberToHex = /*#__PURE__*/__webpack_require__(251);
	
	var _numberToHex2 = /*#__PURE__*/_interopRequireDefault(_numberToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible hex notation.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: rgb(255, 205, 100),
	 *   background: rgb({ red: 255, green: 205, blue: 100 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${rgb(255, 205, 100)};
	 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#ffcd64";
	 *   background: "#ffcd64";
	 * }
	 */
	function rgb(value, green, blue) {
	  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
	    return (0, _reduceHexValue2.default)('#' + (0, _numberToHex2.default)(value) + (0, _numberToHex2.default)(green) + (0, _numberToHex2.default)(blue));
	  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
	    return (0, _reduceHexValue2.default)('#' + (0, _numberToHex2.default)(value.red) + (0, _numberToHex2.default)(value.green) + (0, _numberToHex2.default)(value.blue));
	  }
	
	  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
	}
	
	exports.default = rgb;
	module.exports = exports['default'];

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rgb = /*#__PURE__*/__webpack_require__(175);
	
	var _rgb2 = /*#__PURE__*/_interopRequireDefault(_rgb);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(36);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
	 *
	 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: rgba(255, 205, 100, 0.7),
	 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
	 *   background: rgba(255, 205, 100, 1),
	 *   background: rgba('#ffffff', 0.4),
	 *   background: rgba('black', 0.7),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${rgba(255, 205, 100, 0.7)};
	 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
	 *   background: ${rgba(255, 205, 100, 1)};
	 *   background: ${rgba('#ffffff', 0.4)};
	 *   background: ${rgba('black', 0.7)};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(255,205,100,0.7)";
	 *   background: "rgba(255,205,100,0.7)";
	 *   background: "#ffcd64";
	 *   background: "rgba(255,255,255,0.4)";
	 *   background: "rgba(0,0,0,0.7)";
	 * }
	 */
	function rgba(firstValue, secondValue, thirdValue, fourthValue) {
	  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
	    var rgbValue = (0, _parseToRgb2.default)(firstValue);
	    return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
	  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
	    return fourthValue >= 1 ? (0, _rgb2.default)(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
	  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
	    return firstValue.alpha >= 1 ? (0, _rgb2.default)(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
	  }
	
	  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
	}
	
	exports.default = rgba;
	module.exports = exports['default'];

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(53);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Increases the intensity of a color. Its range is between 0 to 1. The first
	 * argument of the saturate function is the amount by how much the color
	 * intensity should be increased.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: saturate(0.2, '#CCCD64'),
	 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${saturate(0.2, '#FFCD64')};
	 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#e0e250";
	 *   background: "rgba(224,226,80,0.7)";
	 * }
	 */
	function saturate(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    saturation: (0, _guard2.default)(0, 1, hslColor.saturation + amount)
	  }));
	}
	
	var curriedSaturate = /*#__PURE__*/(0, _curry2.default)(saturate);
	exports.default = curriedSaturate;
	module.exports = exports['default'];

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the hue of a color to the provided value. The hue range can be
	 * from 0 and 359.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setHue(42, '#CCCD64'),
	 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setHue(42, '#CCCD64')};
	 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#cdae64";
	 *   background: "rgba(107,100,205,0.7)";
	 * }
	 */
	function setHue(hue, color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    hue: hue
	  }));
	}
	
	var curriedSetHue = /*#__PURE__*/(0, _curry2.default)(setHue);
	exports.default = curriedSetHue;
	module.exports = exports['default'];

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the lightness of a color to the provided value. The lightness range can be
	 * from 0 and 1.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setLightness(0.2, '#CCCD64'),
	 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setLightness(0.2, '#CCCD64')};
	 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#4d4d19";
	 *   background: "rgba(223,224,159,0.7)";
	 * }
	 */
	function setLightness(lightness, color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    lightness: lightness
	  }));
	}
	
	var curriedSetLightness = /*#__PURE__*/(0, _curry2.default)(setLightness);
	exports.default = curriedSetLightness;
	module.exports = exports['default'];

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the saturation of a color to the provided value. The lightness range can be
	 * from 0 and 1.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setSaturation(0.2, '#CCCD64'),
	 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setSaturation(0.2, '#CCCD64')};
	 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#adad84";
	 *   background: "rgba(228,229,76,0.7)";
	 * }
	 */
	function setSaturation(saturation, color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    saturation: saturation
	  }));
	}
	
	var curriedSetSaturation = /*#__PURE__*/(0, _curry2.default)(setSaturation);
	exports.default = curriedSetSaturation;
	module.exports = exports['default'];

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mix = /*#__PURE__*/__webpack_require__(174);
	
	var _mix2 = /*#__PURE__*/_interopRequireDefault(_mix);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shades a color by mixing it with black. `shade` can produce
	 * hue shifts, where as `darken` manipulates the luminance channel and therefore
	 * doesn't produce hue shifts.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: shade(0.25, '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${shade(0.25, '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#00003f";
	 * }
	 */
	
	function shade(percentage, color) {
	  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
	    throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
	  }
	  if (typeof color !== 'string') {
	    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
	  }
	  return (0, _mix2.default)(percentage, color, 'rgb(0, 0, 0)');
	}
	
	var curriedShade = /*#__PURE__*/(0, _curry2.default)(shade);
	exports.default = curriedShade;
	module.exports = exports['default'];

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mix = /*#__PURE__*/__webpack_require__(174);
	
	var _mix2 = /*#__PURE__*/_interopRequireDefault(_mix);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Tints a color by mixing it with white. `tint` can produce
	 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
	 * doesn't produce hue shifts.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: tint(0.25, '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${tint(0.25, '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#bfbfff";
	 * }
	 */
	
	function tint(percentage, color) {
	  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
	    throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
	  }
	  if (typeof color !== 'string') {
	    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
	  }
	  return (0, _mix2.default)(percentage, color, 'rgb(255, 255, 255)');
	}
	
	var curriedTint = /*#__PURE__*/(0, _curry2.default)(tint);
	exports.default = curriedTint;
	module.exports = exports['default'];

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rgb = /*#__PURE__*/__webpack_require__(175);
	
	var _rgb2 = /*#__PURE__*/_interopRequireDefault(_rgb);
	
	var _rgba = /*#__PURE__*/__webpack_require__(104);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _hsl = /*#__PURE__*/__webpack_require__(247);
	
	var _hsl2 = /*#__PURE__*/_interopRequireDefault(_hsl);
	
	var _hsla = /*#__PURE__*/__webpack_require__(248);
	
	var _hsla2 = /*#__PURE__*/_interopRequireDefault(_hsla);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isRgb = function isRgb(color) {
	  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
	};
	
	var isRgba = function isRgba(color) {
	  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
	};
	
	var isHsl = function isHsl(color) {
	  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
	};
	
	var isHsla = function isHsla(color) {
	  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
	};
	
	var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
	
	/**
	 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
	 * This util is useful in case you only know on runtime which color object is
	 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
	 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
	 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
	 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
	 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
	 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
	 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#ffcd64";
	 *   background: "rgba(255,205,100,0.72)";
	 *   background: "#00f";
	 *   background: "rgba(179,25,25,0.72)";
	 * }
	 */
	
	function toColorString(color) {
	  if (typeof color !== 'object') throw new Error(errMsg);
	  if (isRgba(color)) return (0, _rgba2.default)(color);
	  if (isRgb(color)) return (0, _rgb2.default)(color);
	  if (isHsla(color)) return (0, _hsla2.default)(color);
	  if (isHsl(color)) return (0, _hsl2.default)(color);
	
	  throw new Error(errMsg);
	}
	
	exports.default = toColorString;
	module.exports = exports['default'];

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rgba = /*#__PURE__*/__webpack_require__(104);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(36);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _guard = /*#__PURE__*/__webpack_require__(53);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(17);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
	 *
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: transparentize(0.1, '#fff');
	 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
	 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${transparentize(0.1, '#fff')};
	 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
	 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(255,255,255,0.9)";
	 *   background: "rgba(255,255,255,0.8)";
	 *   background: "rgba(255,0,0,0.3)";
	 * }
	 */
	function transparentize(amount, color) {
	  var parsedColor = (0, _parseToRgb2.default)(color);
	  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
	  var colorWithAlpha = _extends({}, parsedColor, {
	    alpha: (0, _guard2.default)(0, 1, (alpha * 100 - amount * 100) / 100)
	  });
	  return (0, _rgba2.default)(colorWithAlpha);
	}
	
	var curriedTransparentize = /*#__PURE__*/(0, _curry2.default)(transparentize);
	exports.default = curriedTransparentize;
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _capitalizeString = /*#__PURE__*/__webpack_require__(249);
	
	var _capitalizeString2 = /*#__PURE__*/_interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var positionMap = ['Top', 'Right', 'Bottom', 'Left'];
	
	
	function generateProperty(property, position) {
	  if (!property) return position.toLowerCase();
	  var splitProperty = property.split('-');
	  if (splitProperty.length > 1) {
	    splitProperty.splice(1, 0, position);
	    return splitProperty.reduce(function (acc, val) {
	      return '' + acc + (0, _capitalizeString2.default)(val);
	    });
	  }
	  var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
	  return property === joinedProperty ? '' + property + position : joinedProperty;
	}
	
	function generateStyles(property, valuesWithDefaults) {
	  var styles = {};
	  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
	    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
	      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
	    }
	  }
	  return styles;
	}
	
	/**
	 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'paddingTop': '12px',
	 *   'paddingRight': '24px',
	 *   'paddingBottom': '36px',
	 *   'paddingLeft': '48px'
	 * }
	 */
	
	function directionalProperty(property) {
	  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  //  prettier-ignore
	  var firstValue = values[0],
	      _values$ = values[1],
	      secondValue = _values$ === undefined ? firstValue : _values$,
	      _values$2 = values[2],
	      thirdValue = _values$2 === undefined ? firstValue : _values$2,
	      _values$3 = values[3],
	      fourthValue = _values$3 === undefined ? secondValue : _values$3;
	
	  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
	  return generateStyles(property, valuesWithDefaults);
	}
	
	exports.default = directionalProperty;
	module.exports = exports['default'];

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pxto = /*#__PURE__*/__webpack_require__(252);
	
	var _pxto2 = /*#__PURE__*/_interopRequireDefault(_pxto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
	 * second argument to the function.
	 * @function
	 * @param {string|number} pxval
	 * @param {string|number} [base='16px']
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'height': em('16px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   height: ${em('16px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'height': '1em'
	 * }
	 */
	
	var em = /*#__PURE__*/(0, _pxto2.default)('em');
	exports.default = em;
	module.exports = exports['default'];

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ratioNames = undefined;
	
	var _stripUnit = /*#__PURE__*/__webpack_require__(176);
	
	var _stripUnit2 = /*#__PURE__*/_interopRequireDefault(_stripUnit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ratioNames = {
	  minorSecond: 1.067,
	  majorSecond: 1.125,
	  minorThird: 1.2,
	  majorThird: 1.25,
	  perfectFourth: 1.333,
	  augFourth: 1.414,
	  perfectFifth: 1.5,
	  minorSixth: 1.6,
	  goldenSection: 1.618,
	  majorSixth: 1.667,
	  minorSeventh: 1.778,
	  majorSeventh: 1.875,
	  octave: 2,
	  majorTenth: 2.5,
	  majorEleventh: 2.667,
	  majorTwelfth: 3,
	  doubleOctave: 4
	
	  /** */
	};
	
	/**
	 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables, see below.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    // Increment two steps up the default scale
	 *   'fontSize': modularScale(2)
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *    // Increment two steps up the default scale
	 *   fontSize: ${modularScale(2)}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'fontSize': '1.77689em'
	 * }
	 */
	function modularScale(steps) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
	  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';
	
	  if (typeof steps !== 'number') {
	    throw new Error('Please provide a number of steps to the modularScale helper.');
	  }
	  if (typeof ratio === 'string' && !ratioNames[ratio]) {
	    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
	  }
	
	  var realBase = typeof base === 'string' ? (0, _stripUnit2.default)(base) : base;
	  var realRatio = typeof ratio === 'string' ? ratioNames[ratio] : ratio;
	
	  if (typeof realBase === 'string') {
	    throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
	  }
	
	  return realBase * Math.pow(realRatio, steps) + 'em';
	}
	
	exports.ratioNames = ratioNames;
	exports.default = modularScale;

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pxto = /*#__PURE__*/__webpack_require__(252);
	
	var _pxto2 = /*#__PURE__*/_interopRequireDefault(_pxto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
	 * second argument to the function.
	 * @function
	 * @param {string|number} pxval
	 * @param {string|number} [base='16px']
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'height': rem('16px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   height: ${rem('16px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'height': '1rem'
	 * }
	 */
	
	var rem = /*#__PURE__*/(0, _pxto2.default)('rem');
	
	exports.default = rem;
	module.exports = exports['default'];

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   '--dimension': stripUnit('100px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   --dimension: ${stripUnit('100px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   '--dimension': 100
	 * }
	 */
	
	function stripUnit(value) {
	  var unitlessValue = parseFloat(value);
	  if (isNaN(unitlessValue)) return value;
	  return unitlessValue;
	}
	
	exports.default = stripUnit;
	module.exports = exports["default"];

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wordWrap = exports.triangle = exports.transparentize = exports.transitions = exports.toColorString = exports.tint = exports.timingFunctions = exports.textInputs = exports.stripUnit = exports.size = exports.shade = exports.setSaturation = exports.setLightness = exports.setHue = exports.selection = exports.saturate = exports.rgba = exports.rgb = exports.retinaImage = exports.rem = exports.readableColor = exports.radialGradient = exports.position = exports.placeholder = exports.parseToRgb = exports.parseToHsl = exports.padding = exports.opacify = exports.normalize = exports.modularScale = exports.mix = exports.margin = exports.lighten = exports.hsla = exports.hsl = exports.hiDPI = exports.hideVisually = exports.hideText = exports.invert = exports.grayscale = exports.getLuminance = exports.fontFace = exports.em = exports.ellipsis = exports.directionalProperty = exports.desaturate = exports.darken = exports.complement = exports.clearFix = exports.buttons = exports.borderWidth = exports.borderStyle = exports.borderRadius = exports.borderColor = exports.backgrounds = exports.backgroundImages = exports.animation = exports.adjustHue = undefined;
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(41);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	var _em = /*#__PURE__*/__webpack_require__(533);
	
	var _em2 = /*#__PURE__*/_interopRequireDefault(_em);
	
	var _modularScale = /*#__PURE__*/__webpack_require__(534);
	
	var _modularScale2 = /*#__PURE__*/_interopRequireDefault(_modularScale);
	
	var _rem = /*#__PURE__*/__webpack_require__(535);
	
	var _rem2 = /*#__PURE__*/_interopRequireDefault(_rem);
	
	var _stripUnit = /*#__PURE__*/__webpack_require__(176);
	
	var _stripUnit2 = /*#__PURE__*/_interopRequireDefault(_stripUnit);
	
	var _clearFix = /*#__PURE__*/__webpack_require__(540);
	
	var _clearFix2 = /*#__PURE__*/_interopRequireDefault(_clearFix);
	
	var _ellipsis = /*#__PURE__*/__webpack_require__(541);
	
	var _ellipsis2 = /*#__PURE__*/_interopRequireDefault(_ellipsis);
	
	var _fontFace = /*#__PURE__*/__webpack_require__(542);
	
	var _fontFace2 = /*#__PURE__*/_interopRequireDefault(_fontFace);
	
	var _hideText = /*#__PURE__*/__webpack_require__(543);
	
	var _hideText2 = /*#__PURE__*/_interopRequireDefault(_hideText);
	
	var _hideVisually = /*#__PURE__*/__webpack_require__(544);
	
	var _hideVisually2 = /*#__PURE__*/_interopRequireDefault(_hideVisually);
	
	var _hiDPI = /*#__PURE__*/__webpack_require__(255);
	
	var _hiDPI2 = /*#__PURE__*/_interopRequireDefault(_hiDPI);
	
	var _normalize = /*#__PURE__*/__webpack_require__(545);
	
	var _normalize2 = /*#__PURE__*/_interopRequireDefault(_normalize);
	
	var _placeholder = /*#__PURE__*/__webpack_require__(546);
	
	var _placeholder2 = /*#__PURE__*/_interopRequireDefault(_placeholder);
	
	var _radialGradient = /*#__PURE__*/__webpack_require__(547);
	
	var _radialGradient2 = /*#__PURE__*/_interopRequireDefault(_radialGradient);
	
	var _retinaImage = /*#__PURE__*/__webpack_require__(548);
	
	var _retinaImage2 = /*#__PURE__*/_interopRequireDefault(_retinaImage);
	
	var _selection = /*#__PURE__*/__webpack_require__(549);
	
	var _selection2 = /*#__PURE__*/_interopRequireDefault(_selection);
	
	var _timingFunctions = /*#__PURE__*/__webpack_require__(550);
	
	var _timingFunctions2 = /*#__PURE__*/_interopRequireDefault(_timingFunctions);
	
	var _triangle = /*#__PURE__*/__webpack_require__(551);
	
	var _triangle2 = /*#__PURE__*/_interopRequireDefault(_triangle);
	
	var _wordWrap = /*#__PURE__*/__webpack_require__(552);
	
	var _wordWrap2 = /*#__PURE__*/_interopRequireDefault(_wordWrap);
	
	var _adjustHue = /*#__PURE__*/__webpack_require__(517);
	
	var _adjustHue2 = /*#__PURE__*/_interopRequireDefault(_adjustHue);
	
	var _complement = /*#__PURE__*/__webpack_require__(518);
	
	var _complement2 = /*#__PURE__*/_interopRequireDefault(_complement);
	
	var _darken = /*#__PURE__*/__webpack_require__(519);
	
	var _darken2 = /*#__PURE__*/_interopRequireDefault(_darken);
	
	var _desaturate = /*#__PURE__*/__webpack_require__(520);
	
	var _desaturate2 = /*#__PURE__*/_interopRequireDefault(_desaturate);
	
	var _getLuminance = /*#__PURE__*/__webpack_require__(246);
	
	var _getLuminance2 = /*#__PURE__*/_interopRequireDefault(_getLuminance);
	
	var _grayscale = /*#__PURE__*/__webpack_require__(521);
	
	var _grayscale2 = /*#__PURE__*/_interopRequireDefault(_grayscale);
	
	var _hsl = /*#__PURE__*/__webpack_require__(247);
	
	var _hsl2 = /*#__PURE__*/_interopRequireDefault(_hsl);
	
	var _hsla = /*#__PURE__*/__webpack_require__(248);
	
	var _hsla2 = /*#__PURE__*/_interopRequireDefault(_hsla);
	
	var _invert = /*#__PURE__*/__webpack_require__(522);
	
	var _invert2 = /*#__PURE__*/_interopRequireDefault(_invert);
	
	var _lighten = /*#__PURE__*/__webpack_require__(523);
	
	var _lighten2 = /*#__PURE__*/_interopRequireDefault(_lighten);
	
	var _mix = /*#__PURE__*/__webpack_require__(174);
	
	var _mix2 = /*#__PURE__*/_interopRequireDefault(_mix);
	
	var _opacify = /*#__PURE__*/__webpack_require__(524);
	
	var _opacify2 = /*#__PURE__*/_interopRequireDefault(_opacify);
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(24);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(36);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _readableColor = /*#__PURE__*/__webpack_require__(525);
	
	var _readableColor2 = /*#__PURE__*/_interopRequireDefault(_readableColor);
	
	var _rgb = /*#__PURE__*/__webpack_require__(175);
	
	var _rgb2 = /*#__PURE__*/_interopRequireDefault(_rgb);
	
	var _rgba = /*#__PURE__*/__webpack_require__(104);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _saturate = /*#__PURE__*/__webpack_require__(526);
	
	var _saturate2 = /*#__PURE__*/_interopRequireDefault(_saturate);
	
	var _setHue = /*#__PURE__*/__webpack_require__(527);
	
	var _setHue2 = /*#__PURE__*/_interopRequireDefault(_setHue);
	
	var _setLightness = /*#__PURE__*/__webpack_require__(528);
	
	var _setLightness2 = /*#__PURE__*/_interopRequireDefault(_setLightness);
	
	var _setSaturation = /*#__PURE__*/__webpack_require__(529);
	
	var _setSaturation2 = /*#__PURE__*/_interopRequireDefault(_setSaturation);
	
	var _shade = /*#__PURE__*/__webpack_require__(530);
	
	var _shade2 = /*#__PURE__*/_interopRequireDefault(_shade);
	
	var _tint = /*#__PURE__*/__webpack_require__(531);
	
	var _tint2 = /*#__PURE__*/_interopRequireDefault(_tint);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(21);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _transparentize = /*#__PURE__*/__webpack_require__(532);
	
	var _transparentize2 = /*#__PURE__*/_interopRequireDefault(_transparentize);
	
	var _animation = /*#__PURE__*/__webpack_require__(553);
	
	var _animation2 = /*#__PURE__*/_interopRequireDefault(_animation);
	
	var _backgroundImages = /*#__PURE__*/__webpack_require__(554);
	
	var _backgroundImages2 = /*#__PURE__*/_interopRequireDefault(_backgroundImages);
	
	var _backgrounds = /*#__PURE__*/__webpack_require__(555);
	
	var _backgrounds2 = /*#__PURE__*/_interopRequireDefault(_backgrounds);
	
	var _borderColor = /*#__PURE__*/__webpack_require__(556);
	
	var _borderColor2 = /*#__PURE__*/_interopRequireDefault(_borderColor);
	
	var _borderRadius = /*#__PURE__*/__webpack_require__(557);
	
	var _borderRadius2 = /*#__PURE__*/_interopRequireDefault(_borderRadius);
	
	var _borderStyle = /*#__PURE__*/__webpack_require__(558);
	
	var _borderStyle2 = /*#__PURE__*/_interopRequireDefault(_borderStyle);
	
	var _borderWidth = /*#__PURE__*/__webpack_require__(559);
	
	var _borderWidth2 = /*#__PURE__*/_interopRequireDefault(_borderWidth);
	
	var _buttons = /*#__PURE__*/__webpack_require__(560);
	
	var _buttons2 = /*#__PURE__*/_interopRequireDefault(_buttons);
	
	var _margin = /*#__PURE__*/__webpack_require__(561);
	
	var _margin2 = /*#__PURE__*/_interopRequireDefault(_margin);
	
	var _padding = /*#__PURE__*/__webpack_require__(562);
	
	var _padding2 = /*#__PURE__*/_interopRequireDefault(_padding);
	
	var _position = /*#__PURE__*/__webpack_require__(563);
	
	var _position2 = /*#__PURE__*/_interopRequireDefault(_position);
	
	var _size = /*#__PURE__*/__webpack_require__(564);
	
	var _size2 = /*#__PURE__*/_interopRequireDefault(_size);
	
	var _textInputs = /*#__PURE__*/__webpack_require__(565);
	
	var _textInputs2 = /*#__PURE__*/_interopRequireDefault(_textInputs);
	
	var _transitions = /*#__PURE__*/__webpack_require__(566);
	
	var _transitions2 = /*#__PURE__*/_interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Shorthands
	
	// Helpers
	exports.adjustHue = _adjustHue2.default;
	exports.animation = _animation2.default;
	exports.backgroundImages = _backgroundImages2.default;
	exports.backgrounds = _backgrounds2.default;
	exports.borderColor = _borderColor2.default;
	exports.borderRadius = _borderRadius2.default;
	exports.borderStyle = _borderStyle2.default;
	exports.borderWidth = _borderWidth2.default;
	exports.buttons = _buttons2.default;
	exports.clearFix = _clearFix2.default;
	exports.complement = _complement2.default;
	exports.darken = _darken2.default;
	exports.desaturate = _desaturate2.default;
	exports.directionalProperty = _directionalProperty2.default;
	exports.ellipsis = _ellipsis2.default;
	exports.em = _em2.default;
	exports.fontFace = _fontFace2.default;
	exports.getLuminance = _getLuminance2.default;
	exports.grayscale = _grayscale2.default;
	exports.invert = _invert2.default;
	exports.hideText = _hideText2.default;
	exports.hideVisually = _hideVisually2.default;
	exports.hiDPI = _hiDPI2.default;
	exports.hsl = _hsl2.default;
	exports.hsla = _hsla2.default;
	exports.lighten = _lighten2.default;
	exports.margin = _margin2.default;
	exports.mix = _mix2.default;
	exports.modularScale = _modularScale2.default;
	exports.normalize = _normalize2.default;
	exports.opacify = _opacify2.default;
	exports.padding = _padding2.default;
	exports.parseToHsl = _parseToHsl2.default;
	exports.parseToRgb = _parseToRgb2.default;
	exports.placeholder = _placeholder2.default;
	exports.position = _position2.default;
	exports.radialGradient = _radialGradient2.default;
	exports.readableColor = _readableColor2.default;
	exports.rem = _rem2.default;
	exports.retinaImage = _retinaImage2.default;
	exports.rgb = _rgb2.default;
	exports.rgba = _rgba2.default;
	exports.saturate = _saturate2.default;
	exports.selection = _selection2.default;
	exports.setHue = _setHue2.default;
	exports.setLightness = _setLightness2.default;
	exports.setSaturation = _setSaturation2.default;
	exports.shade = _shade2.default;
	exports.size = _size2.default;
	exports.stripUnit = _stripUnit2.default;
	exports.textInputs = _textInputs2.default;
	exports.timingFunctions = _timingFunctions2.default;
	exports.tint = _tint2.default;
	exports.toColorString = _toColorString2.default;
	exports.transitions = _transitions2.default;
	exports.transparentize = _transparentize2.default;
	exports.triangle = _triangle2.default;
	exports.wordWrap = _wordWrap2.default;
	
	// Color
	
	
	// Mixins

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// @private
	function capitalizeString(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	exports.default = capitalizeString;
	module.exports = exports["default"];

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = curry;
	
	
	// eslint-disable-next-line no-unused-vars
	function curried(f, length, acc) {
	  return function fn() {
	    // eslint-disable-next-line prefer-rest-params
	    var combined = acc.concat(Array.prototype.slice.call(arguments));
	    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
	  };
	}
	
	// eslint-disable-next-line no-redeclare
	
	// eslint-disable-next-line no-redeclare
	
	// eslint-disable-next-line no-unused-vars
	
	
	// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
	function curry(f) {
	  // eslint-disable-line no-redeclare
	  return curried(f, f.length, []);
	}
	module.exports = exports["default"];

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (string, suffix) {
	  return string.substr(-suffix.length) === suffix;
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function guard(lowerBoundary, upperBoundary, value) {
	  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
	}
	
	exports.default = guard;
	module.exports = exports["default"];

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToRgb = /*#__PURE__*/__webpack_require__(177);
	
	var _hslToRgb2 = /*#__PURE__*/_interopRequireDefault(_hslToRgb);
	
	var _reduceHexValue = /*#__PURE__*/__webpack_require__(253);
	
	var _reduceHexValue2 = /*#__PURE__*/_interopRequireDefault(_reduceHexValue);
	
	var _numberToHex = /*#__PURE__*/__webpack_require__(251);
	
	var _numberToHex2 = /*#__PURE__*/_interopRequireDefault(_numberToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function colorToHex(color) {
	  return (0, _numberToHex2.default)(Math.round(color * 255));
	}
	
	
	function convertToHex(red, green, blue) {
	  return (0, _reduceHexValue2.default)('#' + colorToHex(red) + colorToHex(green) + colorToHex(blue));
	}
	
	function hslToHex(hue, saturation, lightness) {
	  return (0, _hslToRgb2.default)(hue, saturation, lightness, convertToHex);
	}
	
	exports.default = hslToHex;
	module.exports = exports['default'];

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function colorToInt(color) {
	  return Math.round(color * 255);
	}
	
	function convertToInt(red, green, blue) {
	  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
	}
	
	function hslToRgb(hue, saturation, lightness) {
	  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : convertToInt;
	
	  if (saturation === 0) {
	    // achromatic
	    return convert(lightness, lightness, lightness);
	  }
	
	  // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
	  var huePrime = hue % 360 / 60;
	  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
	  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
	
	  var red = 0;
	  var green = 0;
	  var blue = 0;
	
	  if (huePrime >= 0 && huePrime < 1) {
	    red = chroma;
	    green = secondComponent;
	  } else if (huePrime >= 1 && huePrime < 2) {
	    red = secondComponent;
	    green = chroma;
	  } else if (huePrime >= 2 && huePrime < 3) {
	    green = chroma;
	    blue = secondComponent;
	  } else if (huePrime >= 3 && huePrime < 4) {
	    green = secondComponent;
	    blue = chroma;
	  } else if (huePrime >= 4 && huePrime < 5) {
	    red = secondComponent;
	    blue = chroma;
	  } else if (huePrime >= 5 && huePrime < 6) {
	    red = chroma;
	    blue = secondComponent;
	  }
	
	  var lightnessModification = lightness - chroma / 2;
	  var finalRed = red + lightnessModification;
	  var finalGreen = green + lightnessModification;
	  var finalBlue = blue + lightnessModification;
	  return convert(finalRed, finalGreen, finalBlue);
	}
	
	exports.default = hslToRgb;
	module.exports = exports["default"];

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namedColorMap = {
	  aliceblue: 'f0f8ff',
	  antiquewhite: 'faebd7',
	  aqua: '00ffff',
	  aquamarine: '7fffd4',
	  azure: 'f0ffff',
	  beige: 'f5f5dc',
	  bisque: 'ffe4c4',
	  black: '000',
	  blanchedalmond: 'ffebcd',
	  blue: '0000ff',
	  blueviolet: '8a2be2',
	  brown: 'a52a2a',
	  burlywood: 'deb887',
	  cadetblue: '5f9ea0',
	  chartreuse: '7fff00',
	  chocolate: 'd2691e',
	  coral: 'ff7f50',
	  cornflowerblue: '6495ed',
	  cornsilk: 'fff8dc',
	  crimson: 'dc143c',
	  cyan: '00ffff',
	  darkblue: '00008b',
	  darkcyan: '008b8b',
	  darkgoldenrod: 'b8860b',
	  darkgray: 'a9a9a9',
	  darkgreen: '006400',
	  darkgrey: 'a9a9a9',
	  darkkhaki: 'bdb76b',
	  darkmagenta: '8b008b',
	  darkolivegreen: '556b2f',
	  darkorange: 'ff8c00',
	  darkorchid: '9932cc',
	  darkred: '8b0000',
	  darksalmon: 'e9967a',
	  darkseagreen: '8fbc8f',
	  darkslateblue: '483d8b',
	  darkslategray: '2f4f4f',
	  darkslategrey: '2f4f4f',
	  darkturquoise: '00ced1',
	  darkviolet: '9400d3',
	  deeppink: 'ff1493',
	  deepskyblue: '00bfff',
	  dimgray: '696969',
	  dimgrey: '696969',
	  dodgerblue: '1e90ff',
	  firebrick: 'b22222',
	  floralwhite: 'fffaf0',
	  forestgreen: '228b22',
	  fuchsia: 'ff00ff',
	  gainsboro: 'dcdcdc',
	  ghostwhite: 'f8f8ff',
	  gold: 'ffd700',
	  goldenrod: 'daa520',
	  gray: '808080',
	  green: '008000',
	  greenyellow: 'adff2f',
	  grey: '808080',
	  honeydew: 'f0fff0',
	  hotpink: 'ff69b4',
	  indianred: 'cd5c5c',
	  indigo: '4b0082',
	  ivory: 'fffff0',
	  khaki: 'f0e68c',
	  lavender: 'e6e6fa',
	  lavenderblush: 'fff0f5',
	  lawngreen: '7cfc00',
	  lemonchiffon: 'fffacd',
	  lightblue: 'add8e6',
	  lightcoral: 'f08080',
	  lightcyan: 'e0ffff',
	  lightgoldenrodyellow: 'fafad2',
	  lightgray: 'd3d3d3',
	  lightgreen: '90ee90',
	  lightgrey: 'd3d3d3',
	  lightpink: 'ffb6c1',
	  lightsalmon: 'ffa07a',
	  lightseagreen: '20b2aa',
	  lightskyblue: '87cefa',
	  lightslategray: '789',
	  lightslategrey: '789',
	  lightsteelblue: 'b0c4de',
	  lightyellow: 'ffffe0',
	  lime: '0f0',
	  limegreen: '32cd32',
	  linen: 'faf0e6',
	  magenta: 'f0f',
	  maroon: '800000',
	  mediumaquamarine: '66cdaa',
	  mediumblue: '0000cd',
	  mediumorchid: 'ba55d3',
	  mediumpurple: '9370db',
	  mediumseagreen: '3cb371',
	  mediumslateblue: '7b68ee',
	  mediumspringgreen: '00fa9a',
	  mediumturquoise: '48d1cc',
	  mediumvioletred: 'c71585',
	  midnightblue: '191970',
	  mintcream: 'f5fffa',
	  mistyrose: 'ffe4e1',
	  moccasin: 'ffe4b5',
	  navajowhite: 'ffdead',
	  navy: '000080',
	  oldlace: 'fdf5e6',
	  olive: '808000',
	  olivedrab: '6b8e23',
	  orange: 'ffa500',
	  orangered: 'ff4500',
	  orchid: 'da70d6',
	  palegoldenrod: 'eee8aa',
	  palegreen: '98fb98',
	  paleturquoise: 'afeeee',
	  palevioletred: 'db7093',
	  papayawhip: 'ffefd5',
	  peachpuff: 'ffdab9',
	  peru: 'cd853f',
	  pink: 'ffc0cb',
	  plum: 'dda0dd',
	  powderblue: 'b0e0e6',
	  purple: '800080',
	  rebeccapurple: '639',
	  red: 'f00',
	  rosybrown: 'bc8f8f',
	  royalblue: '4169e1',
	  saddlebrown: '8b4513',
	  salmon: 'fa8072',
	  sandybrown: 'f4a460',
	  seagreen: '2e8b57',
	  seashell: 'fff5ee',
	  sienna: 'a0522d',
	  silver: 'c0c0c0',
	  skyblue: '87ceeb',
	  slateblue: '6a5acd',
	  slategray: '708090',
	  slategrey: '708090',
	  snow: 'fffafa',
	  springgreen: '00ff7f',
	  steelblue: '4682b4',
	  tan: 'd2b48c',
	  teal: '008080',
	  thistle: 'd8bfd8',
	  tomato: 'ff6347',
	  turquoise: '40e0d0',
	  violet: 'ee82ee',
	  wheat: 'f5deb3',
	  white: 'fff',
	  whitesmoke: 'f5f5f5',
	  yellow: 'ff0',
	  yellowgreen: '9acd32'
	
	  /**
	   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
	   * @private
	   */
	};function nameToHex(color) {
	  if (typeof color !== 'string') return color;
	  var normalizedColorName = color.toLowerCase();
	  return namedColorMap[normalizedColorName] ? '#' + namedColorMap[normalizedColorName] : color;
	}
	
	exports.default = nameToHex;
	module.exports = exports['default'];

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function numberToHex(value) {
	  var hex = value.toString(16);
	  return hex.length === 1 ? "0" + hex : hex;
	}
	
	exports.default = numberToHex;
	module.exports = exports["default"];

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _endsWith = /*#__PURE__*/__webpack_require__(537);
	
	var _endsWith2 = /*#__PURE__*/_interopRequireDefault(_endsWith);
	
	var _stripUnit = /*#__PURE__*/__webpack_require__(176);
	
	var _stripUnit2 = /*#__PURE__*/_interopRequireDefault(_stripUnit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Factory function that creates pixel-to-x converters
	 * @private
	 */
	var pxtoFactory = function pxtoFactory(to) {
	  return function (pxval) {
	    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';
	
	    var newPxval = pxval;
	    var newBase = base;
	    if (typeof pxval === 'string') {
	      if (!(0, _endsWith2.default)(pxval, 'px')) {
	        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
	      }
	      newPxval = (0, _stripUnit2.default)(pxval);
	    }
	
	    if (typeof base === 'string') {
	      if (!(0, _endsWith2.default)(base, 'px')) {
	        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
	      }
	      newBase = (0, _stripUnit2.default)(base);
	    }
	
	    if (typeof newPxval === 'string') {
	      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
	    }
	
	    if (typeof newBase === 'string') {
	      throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
	    }
	
	    return '' + newPxval / newBase + to;
	  };
	};
	
	exports.default = pxtoFactory;
	module.exports = exports['default'];

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Reduces hex values if possible e.g. #ff8866 to #f86
	 * @private
	 */
	var reduceHexValue = function reduceHexValue(value) {
	  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
	    return "#" + value[1] + value[3] + value[5];
	  }
	  return value;
	};
	
	exports.default = reduceHexValue;
	module.exports = exports["default"];

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function rgbToHsl(color) {
	  // make sure rgb are contained in a set of [0, 255]
	  var red = color.red / 255;
	  var green = color.green / 255;
	  var blue = color.blue / 255;
	
	  var max = Math.max(red, green, blue);
	  var min = Math.min(red, green, blue);
	  var lightness = (max + min) / 2;
	
	  if (max === min) {
	    // achromatic
	    if (color.alpha !== undefined) {
	      return {
	        hue: 0,
	        saturation: 0,
	        lightness: lightness,
	        alpha: color.alpha
	      };
	    } else {
	      return { hue: 0, saturation: 0, lightness: lightness };
	    }
	  }
	
	  var hue = void 0;
	  var delta = max - min;
	  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
	  switch (max) {
	    case red:
	      hue = (green - blue) / delta + (green < blue ? 6 : 0);
	      break;
	    case green:
	      hue = (blue - red) / delta + 2;
	      break;
	    default:
	      // blue case
	      hue = (red - green) / delta + 4;
	      break;
	  }
	
	  hue *= 60;
	  if (color.alpha !== undefined) {
	    return {
	      hue: hue,
	      saturation: saturation,
	      lightness: lightness,
	      alpha: color.alpha
	    };
	  }
	  return { hue: hue, saturation: saturation, lightness: lightness };
	}
	
	exports.default = rgbToHsl;
	module.exports = exports['default'];

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function generateSelectors(template, state) {
	  var stateSuffix = state ? ':' + state : '';
	  return template(stateSuffix);
	}
	
	/**
	 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
	 * @private
	 */
	
	function statefulSelectors(states, template, stateMap) {
	  if (!template) throw new Error('You must provide a template to this method.');
	  if (states.length === 0) return generateSelectors(template, null);
	  var selectors = [];
	  for (var i = 0; i < states.length; i += 1) {
	    if (stateMap && stateMap.indexOf(states[i]) < 0) {
	      throw new Error('You passed an unsupported selector state to this method.');
	    }
	    selectors.push(generateSelectors(template, states[i]));
	  }
	  selectors = selectors.join(',');
	  return selectors;
	}
	
	exports.default = statefulSelectors;
	module.exports = exports['default'];

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to contain a float (credit to CSSMojo).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    ...clearFix(),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${clearFix()}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * '&::after': {
	 *   'clear': 'both',
	 *   'content': '""',
	 *   'display': 'table'
	 * }
	 */
	
	function clearFix() {
	  var _ref;
	
	  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';
	
	  var pseudoSelector = parent + '::after';
	  return _ref = {}, _ref[pseudoSelector] = {
	    clear: 'both',
	    content: '""',
	    display: 'table'
	  }, _ref;
	}
	
	exports.default = clearFix;
	module.exports = exports['default'];

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to represent truncated text with an ellipsis.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...ellipsis('250px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${ellipsis('250px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div: {
	 *   'display': 'inline-block',
	 *   'maxWidth': '250px',
	 *   'overflow': 'hidden',
	 *   'textOverflow': 'ellipsis',
	 *   'whiteSpace': 'nowrap',
	 *   'wordWrap': 'normal'
	 * }
	 */
	
	function ellipsis() {
	  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
	
	  return {
	    display: 'inline-block',
	    maxWidth: width,
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    wordWrap: 'normal'
	  };
	}
	
	exports.default = ellipsis;
	module.exports = exports['default'];

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function generateFileReferences(fontFilePath, fileFormats) {
	  var fileFontReferences = fileFormats.map(function (format) {
	    return 'url("' + fontFilePath + '.' + format + '")';
	  });
	  return fileFontReferences.join(', ');
	}
	
	/** */
	
	
	function generateLocalReferences(localFonts) {
	  var localFontReferences = localFonts.map(function (font) {
	    return 'local("' + font + '")';
	  });
	  return localFontReferences.join(', ');
	}
	
	function generateSources(fontFilePath, localFonts, fileFormats) {
	  var fontReferences = [];
	  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
	  if (fontFilePath) {
	    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
	  }
	  return fontReferences.join(', ');
	}
	
	/**
	 * CSS for a @font-face declaration.
	 *
	 * @example
	 * // Styles as object basic usage
	 * const styles = {
	 *    ...fontFace({
	 *      'fontFamily': 'Sans-Pro'
	 *      'fontFilePath': 'path/to/file'
	 *    })
	 * }
	 *
	 * // styled-components basic usage
	 * injectGlobal`${
	 *   fontFace({
	 *     'fontFamily': 'Sans-Pro'
	 *     'fontFilePath': 'path/to/file'
	 *   }
	 * )}`
	 *
	 * // CSS as JS Output
	 *
	 * '@font-face': {
	 *   'fontFamily': 'Sans-Pro',
	 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
	 * }
	 */
	
	function fontFace(_ref) {
	  var fontFamily = _ref.fontFamily,
	      fontFilePath = _ref.fontFilePath,
	      fontStretch = _ref.fontStretch,
	      fontStyle = _ref.fontStyle,
	      fontVariant = _ref.fontVariant,
	      fontWeight = _ref.fontWeight,
	      _ref$fileFormats = _ref.fileFormats,
	      fileFormats = _ref$fileFormats === undefined ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
	      localFonts = _ref.localFonts,
	      unicodeRange = _ref.unicodeRange;
	
	  // Error Handling
	  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
	  if (!fontFilePath && !localFonts) {
	    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
	  }
	  if (localFonts && !Array.isArray(localFonts)) {
	    throw new Error('fontFace expects localFonts to be an array.');
	  }
	  if (!Array.isArray(fileFormats)) {
	    throw new Error('fontFace expects fileFormats to be an array.');
	  }
	
	  var fontFaceDeclaration = {
	    '@font-face': {
	      fontFamily: fontFamily,
	      src: generateSources(fontFilePath, localFonts, fileFormats),
	      unicodeRange: unicodeRange,
	      fontStretch: fontStretch,
	      fontStyle: fontStyle,
	      fontVariant: fontVariant,
	      fontWeight: fontWeight
	    }
	
	    // Removes undefined fields for cleaner css object.
	  };return JSON.parse(JSON.stringify(fontFaceDeclaration));
	}
	
	exports.default = fontFace;
	module.exports = exports['default'];

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Generates a media query to target HiDPI devices.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *  [hiDPI(1.5)]: {
	 *    width: 200px;
	 *  }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${hiDPI(1.5)} {
	 *     width: 200px;
	 *   }
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
	 *  only screen and (min--moz-device-pixel-ratio: 1.5),
	 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
	 *  only screen and (min-resolution: 144dpi),
	 *  only screen and (min-resolution: 1.5dppx)': {
	 *   'width': '200px',
	 * }
	 */
	
	function hiDPI() {
	  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;
	
	  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
	}
	
	exports.default = hiDPI;
	module.exports = exports["default"];

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to hide text to show a background image in a SEO-friendly way.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'backgroundImage': 'url(logo.png)',
	 *   ...hideText(),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   backgroundImage: url(logo.png);
	 *   ${hideText()};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'backgroundImage': 'url(logo.png)',
	 *   'textIndent': '101%',
	 *   'overflow': 'hidden',
	 *   'whiteSpace': 'nowrap',
	 * }
	 */
	
	function hideText() {
	  return {
	    textIndent: '101%',
	    overflow: 'hidden',
	    whiteSpace: 'nowrap'
	  };
	}
	
	exports.default = hideText;
	module.exports = exports['default'];

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to hide content visually but remain accessible to screen readers.
	 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...hideVisually(),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${hideVisually()};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'border': '0',
	 *   'clip': 'rect(0 0 0 0)',
	 *   'clipPath': 'inset(50%)',
	 *   'height': '1px',
	 *   'margin': '-1px',
	 *   'overflow': 'hidden',
	 *   'padding': '0',
	 *   'position': 'absolute',
	 *   'whiteSpace': 'nowrap',
	 *   'width': '1px',
	 * }
	 */
	
	function hideVisually() {
	  return {
	    border: '0',
	    clip: 'rect(0 0 0 0)',
	    clipPath: 'inset(50%)',
	    height: '1px',
	    margin: '-1px',
	    overflow: 'hidden',
	    padding: '0',
	    position: 'absolute',
	    whiteSpace: 'nowrap',
	    width: '1px'
	  };
	}
	
	exports.default = hideVisually;
	module.exports = exports['default'];

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _opinionatedRules, _abbrTitle, _unopinionatedRules;
	
	var opinionatedRules = (_opinionatedRules = {
	  html: {
	    fontFamily: 'sans-serif'
	  },
	
	  body: {
	    margin: '0'
	  }
	
	}, _opinionatedRules['a:active,\n  a:hover'] = {
	  outlineWidth: '0'
	}, _opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
	  fontFamily: 'sans-serif',
	  fontSize: '100%',
	  lineHeight: '1.15'
	}, _opinionatedRules);
	
	var unopinionatedRules = (_unopinionatedRules = {
	  html: {
	    lineHeight: '1.15',
	    textSizeAdjust: '100%'
	  }
	
	}, _unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
	  display: 'block'
	}, _unopinionatedRules.h1 = {
	  fontSize: '2em',
	  margin: '0.67em 0'
	}, _unopinionatedRules['figcaption,\n  figure,\n  main'] = {
	  display: 'block'
	}, _unopinionatedRules.figure = {
	  margin: '1em 40px'
	}, _unopinionatedRules.hr = {
	  boxSizing: 'content-box',
	  height: '0',
	  overflow: 'visible'
	}, _unopinionatedRules.pre = {
	  fontFamily: 'monospace, monospace',
	  fontSize: '1em'
	}, _unopinionatedRules.a = {
	  'background-color': 'transparent',
	  '-webkit-text-decoration-skip': 'objects'
	}, _unopinionatedRules['abbr[title]'] = (_abbrTitle = {
	  borderBottom: 'none',
	  textDecoration: 'underline'
	}, _abbrTitle['textDecoration'] = 'underline dotted', _abbrTitle), _unopinionatedRules['b,\n  strong'] = {
	  fontWeight: 'inherit'
	}, _unopinionatedRules['code,\n  kbd,\n  samp'] = {
	  fontFamily: 'monospace, monospace',
	  fontSize: '1em'
	}, _unopinionatedRules.dfn = {
	  fontStyle: 'italic'
	}, _unopinionatedRules.mark = {
	  backgroundColor: '#ff0',
	  color: '#000'
	}, _unopinionatedRules.small = {
	  fontSize: '80%'
	}, _unopinionatedRules['sub,\n  sup'] = {
	  fontSize: '75%',
	  lineHeight: '0',
	  position: 'relative',
	  verticalAlign: 'baseline'
	}, _unopinionatedRules.sub = {
	  bottom: '-0.25em'
	}, _unopinionatedRules.sup = {
	  top: '-0.5em'
	}, _unopinionatedRules['audio,\n  video'] = {
	  display: 'inline-block'
	}, _unopinionatedRules['audio:not([controls])'] = {
	  display: 'none',
	  height: '0'
	}, _unopinionatedRules.img = {
	  borderStyle: 'none'
	}, _unopinionatedRules['svg:not(:root)'] = {
	  overflow: 'hidden'
	}, _unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
	  margin: '0'
	}, _unopinionatedRules['button,\n  input'] = {
	  overflow: 'visible'
	}, _unopinionatedRules['button,\n  select'] = {
	  textTransform: 'none'
	}, _unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
	  '-webkit-appearance': 'button'
	}, _unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
	  borderStyle: 'none',
	  padding: '0'
	}, _unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
	  outline: '1px dotted ButtonText'
	}, _unopinionatedRules.fieldset = {
	  border: '1px solid #c0c0c0',
	  margin: '0 2px',
	  padding: '0.35em 0.625em 0.75em'
	}, _unopinionatedRules.legend = {
	  boxSizing: 'border-box',
	  color: 'inherit',
	  display: 'table',
	  maxWidth: '100%',
	  padding: '0',
	  whiteSpace: 'normal'
	}, _unopinionatedRules.progress = {
	  display: 'inline-block',
	  verticalAlign: 'baseline'
	}, _unopinionatedRules.textarea = {
	  overflow: 'auto'
	}, _unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
	  boxSizing: 'border-box',
	  padding: '0'
	}, _unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
	  height: 'auto'
	}, _unopinionatedRules['[type="search"]'] = {
	  '-webkit-appearance': 'textfield',
	  outlineOffset: '-2px'
	}, _unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
	  '-webkit-appearance': 'none'
	}, _unopinionatedRules['::-webkit-file-upload-button'] = {
	  '-webkit-appearance': 'button',
	  font: 'inherit'
	}, _unopinionatedRules['details,\n  menu'] = {
	  display: 'block'
	}, _unopinionatedRules.summary = {
	  display: 'list-item'
	}, _unopinionatedRules.canvas = {
	  display: 'inline-block'
	}, _unopinionatedRules.template = {
	  display: 'none'
	}, _unopinionatedRules['[hidden]'] = {
	  display: 'none'
	}, _unopinionatedRules);
	
	function mergeRules(baseRules, additionalRules) {
	  var mergedRules = _extends({}, baseRules);
	  Object.keys(additionalRules).forEach(function (key) {
	    if (mergedRules[key]) {
	      mergedRules[key] = _extends({}, mergedRules[key], additionalRules[key]);
	    } else {
	      mergedRules[key] = _extends({}, additionalRules[key]);
	    }
	  });
	  return mergedRules;
	}
	
	/**
	 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    ...normalize(),
	 * }
	 *
	 * // styled-components usage
	 * injectGlobal`${normalize()}`
	 *
	 * // CSS as JS Output
	 *
	 * html {
	 *   fontFamily: 'sans-serif',
	 *   lineHeight: 1.15,
	 *   textSizeAdjust: 100%,
	 * } ...
	 */
	function normalize(excludeOpinionated) {
	  if (excludeOpinionated) return unopinionatedRules;
	  return mergeRules(unopinionatedRules, opinionatedRules);
	}
	
	exports.default = normalize;
	module.exports = exports['default'];

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * CSS to style the placeholder pseudo-element.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...placeholder({'color': 'blue'})
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.input`
	 *    ${placeholder({'color': 'blue'})}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'input': {
	 *   '&:-moz-placeholder': {
	 *     'color': 'blue',
	 *   },
	 *   '&:-ms-input-placeholder': {
	 *     'color': 'blue',
	 *   },
	 *   '&::-moz-placeholder': {
	 *     'color': 'blue',
	 *   },
	 *   '&::-webkit-input-placeholder': {
	 *     'color': 'blue',
	 *   },
	 * },
	 */
	
	function placeholder(styles) {
	  var _ref;
	
	  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
	
	  return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = _extends({}, styles), _ref[parent + ':-moz-placeholder'] = _extends({}, styles), _ref[parent + '::-moz-placeholder'] = _extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = _extends({}, styles), _ref;
	}
	
	exports.default = placeholder;
	module.exports = exports['default'];

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = /*#__PURE__*/ _taggedTemplateLiteralLoose(['radial-gradient(', '', '', '', ')'], ['radial-gradient(', '', '', '', ')']);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function parseFallback(colorStops) {
	  return colorStops[0].split(' ')[0];
	}
	
	/** */
	
	
	function constructGradientValue(literals) {
	  var template = '';
	  for (var i = 0; i < literals.length; i += 1) {
	    template += literals[i];
	    // Adds leading coma if properties preceed color-stops
	    if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
	      template = template.slice(0, -1);
	      template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
	      // No trailing space if color-stops is the only param provided
	    } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
	      template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
	      // Only adds substitution if it is defined
	    } else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
	      template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
	    }
	  }
	  return template.trim();
	}
	
	/**
	 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...radialGradient({
	 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
	 *     extent: 'farthest-corner at 45px 45px',
	 *     position: 'center',
	 *     shape: 'ellipse',
	 *   })
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${radialGradient({
	 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
	 *     extent: 'farthest-corner at 45px 45px',
	 *     position: 'center',
	 *     shape: 'ellipse',
	 *   })}
	 *`
	 *
	 * // CSS as JS Output
	 *
	 * div: {
	 *   'backgroundColor': '#00FFFF',
	 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
	 * }
	 */
	
	function radialGradient(_ref) {
	  var colorStops = _ref.colorStops,
	      extent = _ref.extent,
	      fallback = _ref.fallback,
	      position = _ref.position,
	      shape = _ref.shape;
	
	  if (!colorStops || colorStops.length < 2) {
	    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
	  }
	  return {
	    backgroundColor: fallback || parseFallback(colorStops),
	    backgroundImage: constructGradientValue(_templateObject, position, shape, extent, colorStops.join(', '))
	  };
	}
	
	exports.default = radialGradient;
	module.exports = exports['default'];

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hiDPI = /*#__PURE__*/__webpack_require__(255);
	
	var _hiDPI2 = /*#__PURE__*/_interopRequireDefault(_hiDPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A helper to generate a retina background image and non-retina
	 * background image. The retina background image will output to a HiDPI media query. The mixin uses
	 * a _2x.png filename suffix by default.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *  ...retinaImage('my-img')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${retinaImage('my-img')}
	 * `
	 *
	 * // CSS as JS Output
	 * div {
	 *   backgroundImage: 'url(my-img.png)',
	 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
	 *    only screen and (min--moz-device-pixel-ratio: 1.3),
	 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
	 *    only screen and (min-resolution: 144dpi),
	 *    only screen and (min-resolution: 1.5dppx)': {
	 *     backgroundImage: 'url(my-img_2x.png)',
	 *   }
	 * }
	 */
	function retinaImage(filename, backgroundSize) {
	  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';
	
	  var _ref;
	
	  var retinaFilename = arguments[3];
	  var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';
	
	  if (!filename) {
	    throw new Error('Please supply a filename to retinaImage() as the first argument.');
	  }
	  // Replace the dot at the beginning of the passed extension if one exists
	  var ext = extension.replace(/^\./, '');
	  var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;
	
	  return _ref = {
	    backgroundImage: 'url(' + filename + '.' + ext + ')'
	  }, _ref[(0, _hiDPI2.default)()] = {
	    backgroundImage: 'url(' + rFilename + ')',
	    backgroundSize: backgroundSize
	  }, _ref;
	}
	
	exports.default = retinaImage;
	module.exports = exports['default'];

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * CSS to style the selection pseudo-element.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...selection({
	 *     'backgroundColor': 'blue'
	 *   }, 'section')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${selection({'backgroundColor': 'blue'}, 'section')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'section::-moz-selection': {
	 *     'backgroundColor':'blue',
	 *   },
	 *   'section::selection': {
	 *     'backgroundColor': 'blue',
	 *   }
	 * }
	 */
	
	function selection(styles) {
	  var _ref;
	
	  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return _ref = {}, _ref[parent + '::-moz-selection'] = _extends({}, styles), _ref[parent + '::selection'] = _extends({}, styles), _ref;
	}
	
	exports.default = selection;
	module.exports = exports['default'];

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/* eslint-disable key-spacing */
	var functionsMap = {
	  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
	  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
	  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
	  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
	  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
	  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
	  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
	  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
	
	  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
	  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
	  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
	  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
	  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
	  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
	  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
	  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
	
	  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
	  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
	  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
	  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
	  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
	  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
	  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
	  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
	  /* eslint-enable key-spacing */
	
	  /** */
	};
	
	/**
	 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'transitionTimingFunction': timingFunctions('easeInQuad')
	 * }
	 *
	 * // styled-components usage
	 *  const div = styled.div`
	 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
	 * }
	 */
	
	function timingFunctions(timingFunction) {
	  return functionsMap[timingFunction];
	}
	
	exports.default = timingFunctions;
	module.exports = exports['default'];

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/** */
	var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
	  switch (pointingDirection) {
	    case 'top':
	      return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
	    case 'left':
	      return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
	    case 'bottom':
	      return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
	    case 'right':
	      return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';
	
	    default:
	      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
	  }
	};
	
	// needed for border-color
	var reverseDirection = {
	  left: 'Right',
	  right: 'Left',
	  top: 'Bottom',
	  bottom: 'Top'
	
	  /**
	   * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
	   *
	   * @example
	   * // Styles as object usage
	   *
	   * const styles = {
	   *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
	   * }
	   *
	   *
	   * // styled-components usage
	   * const div = styled.div`
	   *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
	   *
	   *
	   * // CSS as JS Output
	   *
	   * div: {
	   *  'borderColor': 'transparent',
	   *  'borderLeftColor': 'red !important',
	   *  'borderStyle': 'solid',
	   *  'borderWidth': '50px 0 50px 100px',
	   *  'height': '0',
	   *  'width': '0',
	   * }
	   */
	
	};function triangle(_ref) {
	  var _ref2;
	
	  var pointingDirection = _ref.pointingDirection,
	      height = _ref.height,
	      width = _ref.width,
	      foregroundColor = _ref.foregroundColor,
	      _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;
	
	  var unitlessHeight = parseFloat(height);
	  var unitlessWidth = parseFloat(width);
	  if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) {
	    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
	  }
	
	  return _ref2 = {
	    borderColor: backgroundColor,
	    width: '0',
	    height: '0',
	    borderWidth: getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
	    borderStyle: 'solid'
	  }, _ref2['border' + reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
	}
	
	exports.default = triangle;
	module.exports = exports['default'];

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Provides an easy way to change the `wordWrap` property.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...wordWrap('break-word')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${wordWrap('break-word')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * const styles = {
	 *   overflowWrap: 'break-word',
	 *   wordWrap: 'break-word',
	 *   wordBreak: 'break-all',
	 * }
	 */
	
	function wordWrap() {
	  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';
	
	  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
	  return {
	    overflowWrap: wrap,
	    wordWrap: wrap,
	    wordBreak: wordBreak
	  };
	}
	
	exports.default = wordWrap;
	module.exports = exports['default'];

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
	 * or a single animation spread over the arguments.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
	 * }
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...animation('rotate', '1s', 'ease-in-out')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${animation('rotate', '1s', 'ease-in-out')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'animation': 'rotate 1s ease-in-out'
	 * }
	 */
	function animation() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  // Allow single or multiple animations passed
	  var multiMode = Array.isArray(args[0]);
	  if (!multiMode && args.length > 8) {
	    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
	  }
	  var code = args.map(function (arg) {
	    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
	      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
	    }
	    if (Array.isArray(arg) && arg.length > 8) {
	      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
	    }
	
	    return Array.isArray(arg) ? arg.join(' ') : arg;
	  }).join(', ');
	
	  return {
	    animation: code
	  };
	}
	
	/** */
	exports.default = animation;
	module.exports = exports['default'];

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
	 * }
	 */
	
	function backgroundImages() {
	  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    backgroundImage: properties.join(', ')
	  };
	}
	
	exports.default = backgroundImages;
	module.exports = exports['default'];

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
	 * }
	 */
	function backgrounds() {
	  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    background: properties.join(', ')
	  };
	}
	
	exports.default = backgrounds;
	module.exports = exports['default'];

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(41);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderColor('red', 'green', 'blue', 'yellow')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderColor('red', 'green', 'blue', 'yellow')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopColor': 'red',
	 *   'borderRightColor': 'green',
	 *   'borderBottomColor': 'blue',
	 *   'borderLeftColor': 'yellow'
	 * }
	 */
	
	function borderColor() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['borderColor'].concat(values));
	}
	exports.default = borderColor;
	module.exports = exports['default'];

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _capitalizeString = /*#__PURE__*/__webpack_require__(249);
	
	var _capitalizeString2 = /*#__PURE__*/_interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderRadius('top', '5px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderRadius('top', '5px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopRightRadius': '5px',
	 *   'borderTopLeftRadius': '5px',
	 * }
	 */
	
	function borderRadius(side, radius) {
	  var uppercaseSide = (0, _capitalizeString2.default)(side);
	  if (!radius && radius !== 0) {
	    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
	  }
	  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
	    var _ref;
	
	    return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
	  }
	
	  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
	    var _ref2;
	
	    return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
	  }
	
	  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
	}
	exports.default = borderRadius;
	module.exports = exports['default'];

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(41);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopStyle': 'solid',
	 *   'borderRightStyle': 'dashed',
	 *   'borderBottomStyle': 'dotted',
	 *   'borderLeftStyle': 'double'
	 * }
	 */
	
	function borderStyle() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['borderStyle'].concat(values));
	}
	exports.default = borderStyle;
	module.exports = exports['default'];

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(41);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderWidth('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderWidth('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopWidth': '12px',
	 *   'borderRightWidth': '24px',
	 *   'borderBottomWidth': '36px',
	 *   'borderLeftWidth': '48px'
	 * }
	 */
	function borderWidth() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['borderWidth'].concat(values));
	}
	exports.default = borderWidth;
	module.exports = exports['default'];

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _statefulSelectors = /*#__PURE__*/__webpack_require__(254);
	
	var _statefulSelectors2 = /*#__PURE__*/_interopRequireDefault(_statefulSelectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateMap = [undefined, null, 'active', 'focus', 'hover'];
	
	
	function template(state) {
	  return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
	}
	
	/**
	 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   [buttons('active')]: {
	 *     'border': 'none'
	 *   }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   > ${buttons('active')} {
	 *     border: none;
	 *   }
	 * `
	 *
	 * // CSS in JS Output
	 *
	 *  'button:active,
	 *  'input[type="button"]:active,
	 *  'input[type=\"reset\"]:active,
	 *  'input[type=\"submit\"]:active: {
	 *   'border': 'none'
	 * }
	 */
	
	function buttons() {
	  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _statefulSelectors2.default)(states, template, stateMap);
	}
	
	exports.default = buttons;
	module.exports = exports['default'];

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(41);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...margin('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${margin('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'marginTop': '12px',
	 *   'marginRight': '24px',
	 *   'marginBottom': '36px',
	 *   'marginLeft': '48px'
	 * }
	 */
	
	function margin() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['margin'].concat(values));
	}
	exports.default = margin;
	module.exports = exports['default'];

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(41);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...padding('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${padding('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'paddingTop': '12px',
	 *   'paddingRight': '24px',
	 *   'paddingBottom': '36px',
	 *   'paddingLeft': '48px'
	 * }
	 */
	
	function padding() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['padding'].concat(values));
	}
	exports.default = padding;
	module.exports = exports['default'];

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(41);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var positionMap = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
	
	/**
	 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...position('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${position('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'top': '12px',
	 *   'right': '24px',
	 *   'bottom': '36px',
	 *   'left': '48px'
	 * }
	 *
	 * // Styles as object usage
	 * const styles = {
	 *   ...position('absolute', '12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${position('absolute', '12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'position': 'absolute',
	 *   'top': '12px',
	 *   'right': '24px',
	 *   'bottom': '36px',
	 *   'left': '48px'
	 * }
	 */
	
	function position(positionKeyword) {
	  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  if (positionMap.indexOf(positionKeyword) >= 0) {
	    return _extends({
	      position: positionKeyword
	    }, _directionalProperty2.default.apply(undefined, [''].concat(values)));
	  } else {
	    var firstValue = positionKeyword; // in this case position is actually the first value
	    return _directionalProperty2.default.apply(undefined, ['', firstValue].concat(values));
	  }
	}
	
	exports.default = position;
	module.exports = exports['default'];

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand to set the height and width properties in a single statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...size('300px', '250px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${size('300px', '250px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'height': '300px',
	 *   'width': '250px',
	 * }
	 */
	
	function size(height) {
	  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
	
	  return {
	    height: height,
	    width: width
	  };
	}
	
	exports.default = size;
	module.exports = exports["default"];

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _statefulSelectors = /*#__PURE__*/__webpack_require__(254);
	
	var _statefulSelectors2 = /*#__PURE__*/_interopRequireDefault(_statefulSelectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateMap = [undefined, null, 'active', 'focus', 'hover'];
	
	
	function template(state) {
	  return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
	}
	
	/**
	 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   [textInputs('active')]: {
	 *     'border': 'none'
	 *   }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   > ${textInputs('active')} {
	 *     border: none;
	 *   }
	 * `
	 *
	 * // CSS in JS Output
	 *
	 *  'input[type="color"]:active,
	 *  input[type="date"]:active,
	 *  input[type="datetime"]:active,
	 *  input[type="datetime-local"]:active,
	 *  input[type="email"]:active,
	 *  input[type="month"]:active,
	 *  input[type="number"]:active,
	 *  input[type="password"]:active,
	 *  input[type="search"]:active,
	 *  input[type="tel"]:active,
	 *  input[type="text"]:active,
	 *  input[type="time"]:active,
	 *  input[type="url"]:active,
	 *  input[type="week"]:active,
	 *  input:not([type]):active,
	 *  textarea:active': {
	 *   'border': 'none'
	 * }
	 */
	
	function textInputs() {
	  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _statefulSelectors2.default)(states, template, stateMap);
	}
	
	exports.default = textInputs;
	module.exports = exports['default'];

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
	 * }
	 */
	
	function transitions() {
	  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    transition: properties.join(', ')
	  };
	}
	
	exports.default = transitions;
	module.exports = exports['default'];

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(203);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(161);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(196);
	
	var _HelmetConstants = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(165);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(205);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 399:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  from ', '\n  to ', '\n'], ['\n  from ', '\n  to ', '\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: block;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: ', ';\n    z-index: 2;\n\n    opacity: ', ';\n    animation-name: ', ';\n    animation-duration: ', 'ms;\n    animation-timing-function: ease-in-out;\n    animation-fill-mode: \'forwards\';\n  '], ['\n    display: block;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: ', ';\n    z-index: 2;\n\n    opacity: ', ';\n    animation-name: ', ';\n    animation-duration: ', 'ms;\n    animation-timing-function: ease-in-out;\n    animation-fill-mode: \'forwards\';\n  ']);
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactRedux = __webpack_require__(198);
	
	var _reactTransitionGroup = __webpack_require__(288);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(536);
	
	var _navigation = __webpack_require__(115);
	
	var navigation = _interopRequireWildcard(_navigation);
	
	var _transition = __webpack_require__(211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var op1 = '{ opacity: 1; }';
	var op0 = '{ opacity: 0; }';
	var animateIn = (0, _styledComponents.keyframes)(_templateObject, op0, op1);
	var animateOut = (0, _styledComponents.keyframes)(_templateObject, op1, op0);
	
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    return React.createElement(Overlay.Bg, { active: this.props.active });
	  };
	
	  return Overlay;
	}(React.Component);
	
	Overlay.Bg = _styledComponents2.default.div(_templateObject2, function (props) {
	  return (0, _polished.rgba)(props.theme.colors.light, 0.95);
	}, function (props) {
	  return props.active ? 1 : 0;
	}, function (props) {
	  return props.active ? animateIn : animateOut;
	}, function (props) {
	  return props.theme.transition.standard;
	});
	
	var NavigationOverlay = function (_React$Component2) {
	  _inherits(NavigationOverlay, _React$Component2);
	
	  function NavigationOverlay() {
	    _classCallCheck(this, NavigationOverlay);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NavigationOverlay.prototype.render = function render() {
	    var _props = this.props,
	        navActive = _props.navActive,
	        theme = _props.theme;
	
	    return React.createElement(
	      _reactTransitionGroup.Transition,
	      { 'in': navActive, timeout: theme.transition.standard + 10 },
	      function (state) {
	        return state !== _transition.TRANSITION_STATES.EXITED && React.createElement(Overlay, {
	          active: [_transition.TRANSITION_STATES.ENTERING, _transition.TRANSITION_STATES.ENTERED].includes(state)
	        });
	      }
	    );
	  };
	
	  return NavigationOverlay;
	}(React.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    navActive: navigation.selectors.isActive(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _styledComponents.withTheme)(NavigationOverlay));
	module.exports = exports['default'];

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(195);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(11);
	
	var _theme = __webpack_require__(314);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	__webpack_require__(401);
	
	var _NavigationOverlay = __webpack_require__(309);
	
	var _NavigationOverlay2 = _interopRequireDefault(_NavigationOverlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(400);
	__webpack_require__(399);
	
	(0, _theme.injectGlobalStyles)(_styledComponents.injectGlobal);
	
	var TemplateWrapper = function (_PureComponent) {
	  _inherits(TemplateWrapper, _PureComponent);
	
	  function TemplateWrapper() {
	    _classCallCheck(this, TemplateWrapper);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TemplateWrapper.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_NavigationOverlay2.default, null),
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: 'Tom Allen Photo',
	          meta: [{ name: 'description', content: 'Tom Allen Photo' }, {
	            name: 'keywords',
	            content: 'Photography, UK, Landscape, Cityscape, Animals'
	          }]
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          children()
	        )
	      )
	    );
	  };
	
	  return TemplateWrapper;
	}(_react.PureComponent);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  body, body * {\n    font-family: \'', '\';\n  }\n  html {\n    font-size: 18px;\n  }\n'], ['\n  body, body * {\n    font-family: \'', '\';\n  }\n  html {\n    font-size: 18px;\n  }\n']);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var theme = {
	  units: {
	    baseUnit: 1 // 1 rem,
	  },
	  colors: {
	    light: '#FFFFFF',
	    dark: '#101010'
	    // lightCream: '#E6DFD6',
	    // darkCream: '#C5AB97',
	  },
	  breakPoints: {
	    // (lower limit)
	    med: 360,
	    lrg: 760
	  },
	  fonts: {
	    heading: 'Yeseva One',
	    main: 'PT Sans'
	  },
	  transition: {
	    standard: 450,
	    short: 300
	  }
	};
	
	var injectGlobalStyles = exports.injectGlobalStyles = function injectGlobalStyles(injectGlobal) {
	  injectGlobal(_templateObject, theme.fonts.main);
	};
	
	exports.default = theme;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-df6c79e4c8e0f13b37f5.js